import { Helmet } from '@dr.pogodin/react-helmet';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import Loading from '../common/lib/Loading';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import Functions from '../functions';
import MediaWikiUtils, { type MediaWikiPageData } from './lib/MediaWikiUtils';
import './assets/style.css';

interface Props {
    lang: MultiLang;
    name: string;
}

const MediaWiki = (props: Props) => {
    const { lang, name } = props;
    const [state, setState] = useState<{ name: string; page: MediaWikiPageData | null } | null>(null);

    useEffect(() => {
        let active = true;
        void MediaWikiUtils.getPage(name).then((page) => {
            if (active) {
                setState({ name, page });
            }
        });
        return () => {
            active = false;
        };
    }, [name]);

    if (state === null || state.name !== name) {
        return <Loading />;
    }
    const { page } = state;
    if (page === null) {
        return <PageNotFound lang={lang} />;
    }
    return (
        <div className="mediawiki">
            <Helmet>
                <title>
                    {Functions.mlang(page.title, lang)} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <NoticeSiteHasBeenArchived lang={lang} />
            <div className="mw-header">
                <div className="navigation">
                    <Link to="/mediawiki/メインページ?ml_lang=ja">メインページ (Japanese)</Link>|
                    <Link to="/mediawiki/Main_Page?ml_lang=en">Main Page (English)</Link>
                </div>
            </div>
            <hr />
            <div className="mw-body">
                <h1 className="firstHeading">{Functions.mlang(page.title, lang)}</h1>
                <div className="mw-content">
                    <div className="mw-content-text">
                        <XoopsCode lang={lang} text={page.text} dohtml={true} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MediaWiki;
